import type { LocationQuery } from "vue-router";

/**
 * Where to send someone after they sign in. The interceptor and the router guard put the URL
 * the user was trying to reach in `?redirect=`; without this they land on the dashboard and
 * have to find their way back — which for a notification deep link means hunting for the
 * notification again.
 *
 * Only relative in-app paths are honoured, and only ones belonging to the portal being signed
 * into, so a crafted link cannot bounce a user off-site or across portals.
 */
export const resolveLoginRedirect = (
  query: LocationQuery,
  portal: "admin" | "customer"
): string => {
  const fallback = portal === "admin" ? "/admin" : "/";
  const target = query.redirect;

  if (typeof target !== "string" || !target.startsWith("/")) {
    return fallback;
  }
  // "//evil.example" is a protocol-relative URL, not an in-app path.
  if (target.startsWith("//")) {
    return fallback;
  }
  const isAdminPath = target.startsWith("/admin");
  if (isAdminPath !== (portal === "admin")) {
    return fallback;
  }
  if (target.startsWith("/login") || target.startsWith("/admin/login")) {
    return fallback;
  }
  return target;
};
